import { warnIfDevBuild } from 'utils/environment';
warnIfDevBuild('login');
import 'tradera/legacy/static/app/';
import InitData from 'tradera/legacy/static/app/data/init-data';
import ChangePassword from './app/pages/change-password';
import EnterCellphoneVerification from './app/pages/enter-cellphone-verification-code';
import PasswordRecovery from './app/pages/password-recovery';
import Login from './app/pages/login';
import VerifyBankId from './app/pages/verify-bank-id';
import BankIdPasswordRecovery from './app/pages/bank-id-password-recovery';
import { logger } from 'packages/logger';
import '../style/module-includes';

const initData = InitData.currentOrSet();

const modules = {
    'change-password': ChangePassword,
    'enter-cellphone-verification-code': EnterCellphoneVerification,
    'password-recovery': PasswordRecovery,
    login: Login,
    'verify-bankId': VerifyBankId,
    'bankId-password-recovery': BankIdPasswordRecovery
};

if (initData && initData.subModule) {
    const mod = initData.subModule.split('pages/');
    const moduleKey = mod[1];
    const moduleInitFunction = modules[moduleKey];
    if (moduleInitFunction) {
        try {
            moduleInitFunction(initData);
        } catch (e) {
            logger(e);
        }
    }
}
